export default {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  CLOZE: 'CLOZE'
};
